export const FR = {
  banner: {
    error: "Les prix ne sont pas mis à jour, merci de patienter",
    copicate: "Essayez le nouveau mode portefeuille!",
    antimonitor: "Le bon site pour acheter des Crypto-monaies? Cliquez-ici!",
  },
  footer: {
    donating: "Si vous aimez Cointrack, votre donation est la bienvenue !",
    right_reserve:
      "© Copyright " +
      new Date().getFullYear() +
      " by CoinTrackr.com. Tous droits réservés.",
    version: "Version",
    changelog: "Historique des versions",
    powered_by: "Développé par",
  },
  top: {
    about: {
      info: "Info",
      FAQ: "FAQ",
      contact: "Contacts",
      partners: "Partenaires",
      terms: "Conditions",
      privacy: "Protection de données",
    },
  },
  content: {
    valuation: {
      current_valuation: "Valorisation actuelle",
      approx: "Approx.",
    },
    profit_losses: "Evolution du portefeuille",

    updating_assets: " Mise à jour...",
    updated_now: "Mis à jour à l'instant",
    last_update: "Dernière mise à jour il y a {time} secondes",
    last_update_minutes: `Dernière mise à jour il y a {minutes} mn et {seconds} sec`,
  },
  assets: {
    your_assets: "Cryptos",
    add_asset: "Ajouter une Crypto",
    sort: "Classer par",
    sort_name: {
      name: "Nom",
      exchId: "Courtier",
      price: "Prix",
      value: "Valorisation",
      holdings: "Quantité",
      percChangeHour: "Heure",
      percChangeDay: "Jour",
      percChangeWeek: "Semaine",
    },
  },
  charts: {
    color_help: "Cliquez sur un cercle pour changer une couleur",
  },
  contact_page: {
    contact: "Contact",
    help_feedback: "Aide & Feedback",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium:",
    busines: "Contact commercial",
    email: "Email",
  },
  partner_page: {
    partners: "Nos partenaires",
    bitsify: "Bitsify fournit des rapports complets détaillés sur les ICOs.",
    bitcoin:
      "Bitcoin for Beginners est votre communauté pour apprendre sur les Crypto-monnaies.",
    interest: "Intéressé par un partenariat ?",
    contact_us: "Contactez-nous!",
  },
  user_menu: {
    not_logged: "Pas connecté",
    icognito: "Incognito",
    settings: "Paramètres",
    sign_in: "Se connecter",
    sign_out: "Se déconnecter",
    valuation: "Ma valorisation sur l'onglet",
    incognito: "Mode Incognito",
    night_mode: "Mode nuit",
    share_link: "Créer un lien partageable",
  },
  FAQ: {
    expand: "Tout développer",
    collapse: "Tout réduire",
    0: {
      title: "Cointrackr qu'est- ce que c'est?",
      text:
        "CoinTrackr est un service gratuit, simple et pratique conçu pour vous aider à suivre vos investissements en Crypto-monnaie.",
    },
    1: {
      title: "Comment je crée un portefeuille dans Cointrackr?",
      text:
        "C'est simple ! Supprimez simplement les Crypto- monnaies du portefeuille exemple et remplacez- les par les vôtres.Vous pouvez supprimer ou modifier une Crypto en cliquant dessus.",
    },
    2: {
      title: "Où Cointrackr obtient-il les prix et sont-ils précis?",
      text:
        'Toutes les données relatives aux prix proviennent de <a href="https://coinmarketcap.com"> coinmarketcap.com </a> et représentent le prix moyen entre les bourses prises en charge par CoinMarketCap. Parce que CoinTrackr utilise des prix moyens, ils peuvent différer légèrement du prix exact de la bourse que vous suivez.',
    },
    3: {
      title: "Comment ajouter ma clé API et Trader depuis CoinTrackr?",
      text:
        'Il suffit de suivre les instructions sur la page dédiée <a href="/exchange/how-it-works">ici</a> ',
    },
    4: {
      title: "Planifiez-vous d'ajouter d'autres Courtiers?",
      text:
        "Oui, nous avons prevu d'ajouter tous les courtiers qui permettent une intéraction avec des clé API pour leur clients",
    },
    5: {
      title:
        "Qu'est - ce que la valorisation et comment en déterminez - vous le montant ? ",
      text:
        "La valorisation correspond à la valeur totale de tous vos actifs ajoutés à CoinTrackr; la valeur totale de votre portefeuille de Crypto-monnaies actuel.",
    },
    6: {
      title: "Pourquoi je ne retrouve pas certaines Crypto-monnaies?",
      text:
        "Si vous avez bien orthographié le nom de la Crypto-monnaie et qu’on ne la trouve pas, il est possible que CoinMarketCap ne l'index pas encore.Nous travaillons sur l'ajout de plusieurs sources pour les données de prix, il est donc très probable que votre Cryptomonnaie sera prise en charge à l'avenir.",
    },
    7: {
      title:
        "Comment stockez-vous mon portefeuille et mes données de connexion?",
      text:
        'Si vous n"êtes pas connecté(e), toutes les données sont enregistrées dans la mémoire cache de votre navigateur.Vous pouvez fermer la fenêtre et revenir plus tard, sans avoir à ajouter vos Cryptos à nouveau.' +
        "\n" +
        "Si vous vous êtes inscrit sur CoinTrackr (identifiant social / email et mot de passe), vos données sont stockées dans notre base de données. Nous faisons cela pour rendre possible la synchronisation en temps réel entre vos différents appareils (bureau et mobile, par exemple) et pour que les données soient stockées même si vous effacez le cache du navigateur.",
    },
    8: {
      title: "Un compte CoinTrackr est-il sécurisé?",
      text:
        'Oui. Nous utilisons vos données uniquement pour rendre possible le fonctionnement clé de CoinTrackr. Nous ne communiquons aucune de vos données à des tiers en aucune circonstance. Veuillez consulter notre <a href="/privacy"> politique de confidentialité <a/> pour plus d’informations.',
    },
    9: {
      title:
        "Est-ce que CoinTrackr serait intéressé par une coopération avec mon service / communauté lié aux Crypto-monnaies?",
      text:
        'Bien sur, veuillez <a href="/contact"> nous contacter pour en  discuter',
    },
  },
  add_page: {
    search: "Recherche par nom ou symbole",
    add_asset: "Ajouter une Crypto",
    any_asset: {
      1: "Tout actif (Crypto-monnaie ou Token) qui est listé à",
      2: "est pris en charge.",
    },
    next: "Suivant",
    no_result: "Pas de résultats trouvés pour",
  },
  register_page: {
    register: "Inscription",
    agree: "En vous inscrivant, vous acceptez nos",
    terms: "Conditions générales",
    and: "et",
    privacy: "Notre politique de confidentialité",
    p_reg:
      "L'inscription est requise si vous souhaitez <b>sauvegarder votre portefeuille</b> pour l'utiliser dans <b>un autre appareil</b>, où pour le sécuriser dans le cas où <b>vous effacez le cache de votre navigateur</b>",
    errors: {
      email_required: "Votre Email est requis.",
      email_valid: 'L"Email doit être valide.',
      password_required: "Mot de passe requis.",
      password_length:
        "Votre mot de passe doit comporter au moins {length} caractères",
      password_match: "Les mots de passe doivent correspondre.",
    },
    placeholder: {
      email: "Saisissez votre Email",
      password: "Saisissez votre mot de passe",
      password_repeat: "Re-saisissez votre mot de passe",
    },
    create_account: "Créer un compte",
  },
  login_page: {
    placeholder: {
      email: "Saisissez votre Email",
      password: "Saisissez votre mot de passe",
    },
    errors: {
      email_not_found:
        'Il n"y a pas d"enregistrement d"utilisateur correspondant à cet identifiant.L"utilisateur peut avoir été supprimé.',
      not_email: 'L"adresse Email est mal formatée.',
    },
    forget_password_text:
      "Si vous oubliez votre mot de passe, cliquez ici pour le réinitialiser",
    forget_password_text_back: "retour à la connexion",
    reset_password: "Réinitialisation de votre mot passe",
    reset_password_p:
      "Saisissez votre adresse e-mail ci-dessous si vous souhaitez recevoir un e-mail vous permettant de réinitialiser votre mot de passe.",
    reset_password_success:
      "Le message de réinitialisation du mot de passe pour CoinTrackr a été envoyé. Vérifiez votre boîte de réception et revenez.",
    // forget_password_text: 'Si vous avez oublié votre mot de passe, merci de nous contacter à <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> afin de le réinitialiser',
  },
  share_page: {
    heading: "Créer un lien partageable",
    just_second: "Juste une seconde...",
    porfolio_not_found: "Portfolio non trouvé",

    p_1:
      "<strong>CoinTrackr</strong> est un gestionnaire de <strong>portefeuille de crypto-monnaie gratuit</strong> qui vous permet de suivre vos profits et vos pertes <strong>et de partager votre portefeuille avec d'autres.</strong>.",
    create_own: "Créez le vôtre gratuitement",

    p_2:
      "<strong>Quelqu'un a partagé son portfolio avec vous!</strong> <br> CoinTrackr est un service gratuit de portefeuille de Crypto-devises prenant en charge plus de 4 000 Crypto-monnaies et Tokens.",
    porfolio: "Portefeuille",
    profit_losed: "Profits et pertes",

    created: "Créé",
    dialog: {
      p_1:
        "Le partage de votre portefeuille crée un <strong>lien public</strong> qui affiche votre <strong>portefeuille anonyme.</strong> Il ne contient<strong>que des pourcentages</strong> et aucune évaluation ou prix. Il ne peut pas être lié à vous et peut être partagé en toute sécurité avec quiconque.",
      add_message: "<strong>Ajouter un message</strong> <em>(optionnel)</em>",
    },
    create_shareble: "Créer un lien partageable",
    create_own_free: "Créez votre propre portefeuille",
    messages: {
      already: "Votre lien de portefeuille est prêt à être partagé! 🙌",
      copied: "Votre lien a été copié! 🎉",
      not_copied:
        "Votre lien ne peut pas être copié, merci de le copier manuellement. 😢",
      failed: "La création de lien à échoué, veuillez ressay. 😢",
    },
  },
  global: {
    add_first: "Add your first asset",

    not_now: "Pas tout de suite",
    not_right_now: "Pas tout de suite",
    close: "Fermer",
    go_back: "Retour",
    share: "%Repart.",

    price: "Prix",

    day: "Jour",
    hour: "Heure",
    week: "Semaine",
    valuation: "Valorisation",
    holdings: "Quantité",
    name: "Nom",
    actions: "Actions",
    edit: "Éditer",
    notes: "Notas",

    last_7_days: "7 derniers jours",
    last_24_hour: "Depuis 24 heures",
    last_hour: "Depuis 1 heure",

    login: "S'identifier",
  },
  sign_in_dialog: {
    button: {
      email: "Se connecter avec Email",
      facebook: "Se connecter avec Facebook",
      google: "Se connecter avec Google",
      twitter: "Se connecter avec Twitter",
    },
    p:
      "L'inscription est requise si vous souhaitez <b>sauvegarder votre portefeuille</b> pour l'utiliser dans <b>un autre appareil</b>, où pour le sécuriser dans le cas où <b>vous effacez le cache de votre navigateur</b>",
  },
  notifications: {
    sign_in: "Vous êtes connecté",
    sign_out: "Vous êtes déconnecté",
    HODL: "Vous ne conservez pas 😭 ?",
    dont_worry:
      "Ne vous inquietez pas, soyez heureux maintenant .... et conservez! 🎶 🚀",
  },
  edit_asset_page: {
    add: "Ajouter ou Modifier",
    how_much: "Combien de {assetName} {assetSymbol} vous détenez?",
    save: "Sauvegarder",
    delete: "Supprimer",
    notes_label: "Notes pour {assetName} {assetSymbol}",
    notes_placeholder:
      "Ajoutez ici vos notes, comme vos prix d'achat, courtier, adresse de portefeuille ou tout autre commentaire sur la crypto",
  },
  exchange: {
    exchange: "Courtier",
    trade: "Trader",

    your_api_keys: "Vos clés API",
    how_it_works: "Comment ca marche?",

    home_valuation_per_exchange: "Valorisation par Courtier",
    home_show_valuation_per_exchange: "Montrer la Valo par Courtier",
    home_tooltip_info: "Plus d'info sur les clés API",

    api_key: "Clé API",
    secret: "Clé API secrete",
    add: "Ajouter",
    update: "Mettre à jour",
    cancel: "Annuler",
    add_your_exchange_api_key: "Ajouter votre clé API {exchange}",
    add_exchange_api_key: "Ajouter une clé API {exchange}",
    update_exchange_api_key: "Màj clé API {exchange}",
    api_keys_page_note:
      "Important: Il y a un délai de rafraichissement de 15mn imposé par Binance après un dépot/retrait ou un ordre excecuté.<br/> Les cotations sont elles en live",

    pick_a_ticker_to_trade: "Choisissez une paire à Trader:",
    select_ticker: "Selectionnez la paire",

    loading: "Chargement...",
    Buy: "Achat",
    Sell: "Vente",
    LIMIT: "LIMITE",
    MARKET: "MARCHE",

    amount: "Montant",
    you_have: "Vous avez",
    total: "Total",

    place_buy_order: "Placer ordre d'Achat",
    place_sell_order: "Placer ordre de Vente",

    order_placed: "Commande passée!",

    you_dont_have_assets: "Vous n'avez pas la Crypto",

    orders_history: "Historique de transaction",
    orders_open: "Ordres ouverts",
    orders_history_empty:
      "L'historique des Transactions pour {ticker} est vide",
    orders_open_empty: "Pas d'ordres ouverts pour {ticker} pour le moment",
    symbol: "Symbole",
    side: "Sens",
    type: "Type",
    price: "Prix",
    status: "Statut",
    stopPrice: "Stop",
    executedQty: "Qté exe",
    time: "Date",
    action: "Action",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "Màj importante de CoinTrackr",
        p: [
          "Après de nombreuses années à vous fournir des cotations par milliards pour tous nos utilisateurs, CoinTrackr est fier de vous annoncer une mise à jour prometteuse. Dès aujourd'hui vous aurez la possibilité de suivre vos Cryptos que vous avez chez vos différents courtiers sur CoinTrackr!",
          "Encore une chose... Pas seulement suivre vos crypto! CoinTrackr est fier d'annoncer une option pour Trader vos Cryptos en plus de les suivre sur notre site!",
        ],
      },
      {
        heading: "Comment ça marche?",
        p: [
          "Les principaux courtiers en Crypto proposent d'utiliser leur API afin de connecter toute autre plateforme que la leur. Par exemple, comme vous pouvez le voir ci-dessous, Binance offre cette option à cet endroit",
          '1) Inscrivez-vous à CoinTrackr ensuite rendez-vous dans le menu "Vos clés API"',
          "2) Copiez/Collez depuis votre compte Binance vos deux clés API, voici une image ci-dessous illustrant cette manipulation",
          "<em>IMPORTANT</em,>: N'activez QUE “<strong>Enable reading</strong>” & “<strong>Enable Spot & Margin Trading</strong>” puis dans \"IP Restriction\" indiquez l'adresse de notre serveur qui est : <strong>{exchangeApiIP}</strong>",
          "Une fois cela effectué, vous devez patienter 15mn environ de temps de synchro, puis rendez-vous vers notre page d'accueil et vous découvrirez vos Cryptos que vous détenez chez Binance représentés par l'icône Binance.",
          'Chose importante également, afin vos Cryptos dites "classiques" avaient le bouton "editer" en fin de ligne, evidement ici le bouton devient "trader" car dès aujourd\'hui vous pouvez manager et trader votre portefeuille Binance depuis CoinTrackr.',
          "Regardons maintenant à quoi ressemble maintenant le panneau principal de CoinTrackr:",
          "Bien sûr, dès le premier bloc, vous avez d'afficher la ventilation de vos Cryptos selon qu'ils soient chez Binance ou en \"Classique\" CoinTrackr comme auparavant..",
          "Comme vous pouvez également le voir ici, vous avez une nouvelle colonne qui différencie les Crypto par courtier:<br /> > Le logo CoinTrackr est is pour les Cryptos en cold wallet comme avant.<br /> > Le logo Binance, représente en temps réel les Cryptos que vous détenez chez ce dernier.",
        ],
      },
      {
        heading: "Plateforme de Trading",
        p: [
          "(sous réserve d’acceptation de nos conditions générales)",
          'Maintenant voyons comment CoinTrackr vous permet de Trader vos Cryptos de chez Binance. Vous avez accès à la plateforme de Trading à tout instant en cliquant sur "Trader"',
          'Ici, après avoir cliqué sur "Trader", vous avez comme choix de : "Acheter/Vendre", avec deux paramètres "Ordre limite" et "Ordre marché" pour chacune de vos Cryptos',
          'Note: afin d\'activer cette option, vous devez impérativement configurer votre clé API Binance en activant l\'option "Enable Spot & Margin Trading", pour cela <a href="#step-2-binance-setup">cliquez ici pour revoir la configuration API Binance nécessaire</a>.',
          "Bien évidemment, si vous ne souhaitez pas utiliser cette option, vous pourrez tout à fait continuer à suivre vos Cryptos de chez Binance sans les Trader.",
          "Aujourd'hui, le premier courtier que nous vous proposons est Binance, à suivre d'autres vont se greffer à CoinTrackr :)",
          '<a href="mailto:info@cointrackr.com">info@cointrackr.com</a> si vous avez la moindre question ou si vous trouvez un bug, merci!',
        ],
      },
    ],
  },
  profitloss: {
    pl: "G/P",
    profitloss: "Gains/Pertes",
    realized_profitloss: "Gain/Perte soldés",
    total_balance: "Solde",
    mode: "Mode",
    portfolio: "Portefeuille",
    current: "Actuel",
    history: "Historique",
    investment: "Investissement",
    average: "Moyenne",
    transaction: "Transaction",
    transactions: "Transaction",
    hide: "Cacher",
    show: "Montrer",
    asset_notes_label: "Notes pour cet actif",
    asset_notes_placeholder: "Ajoutez ici toute note(s) correspondant à cet actif ou transaction",
    reset_portfolio: "Remettre à 0",
    reset_portfolio_text: "Voulez-vous supprimer toute les transactions?",
    list_empty: "La liste est vide",

    quantity: "Quantité",
    value: "Valeur",
    date: "Date",
    buy_price: "Prix d'achat",
    buy_value: "Valeur d'achat",
    buy_date: "Date d'achat",
    showInValuation_help: "Inclurer les Gains/Perte dans la valorisation actuelle",
    transaction_notes_placeholder: "Ajoutez ici toute note(s) correspondant à cette transaction",
    sell_close: "Vendre/Fermer",
    total_valuation: "Valorisation totale",
    delete_transaction_text: "Supprimer cette transaction?",

    sell_price: "Prix de vente",
    sell_value: "Valeur vente",
    sell_date: "Date de ventre",
    history_transaction_hint: "Transaction cloturée",

    original_buy_transaction: "1er achat depuis {date}",
    left_unsold: "Quantité restante",
    originally: "initialement",
    dependent_transactions: "Vous avez {count} transaction(s) fermé(es) de cet actif pour {amount} au total",
  },
};
